export default {
  // Notifications
  async getNotifications(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications${query ? '?' + query : ''}`);
  },

  async markNotificationRead(notificationId) {
    return this.request(`/notifications/${notificationId}/read`, { method: 'POST' });
  },

  async markAllNotificationsRead(params = {}) {
    // Scoped: marking everything read must mean the space you are looking at, not
    // whatever the server defaults to.
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications/mark-all-read${query ? '?' + query : ''}`, { method: 'POST' });
  },

  async dismissNotification(notificationId) {
    return this.request(`/notifications/${notificationId}`, { method: 'DELETE' });
  },

  async getNotificationCounts(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications/counts${query ? '?' + query : ''}`);
  },

  async getNotificationSettings() {
    return this.request('/notifications/settings');
  },

  async updateNotificationSettings(patch) {
    return this.request('/notifications/settings', { method: 'PUT', body: patch });
  },

  // Activity Feed. Personal by default; pass groupId for that group's ledger,
  // which shows every member's work on the group's nodes, not just your own.
  async getActivityFeed(params = {}, groupId = null) {
    const query = new URLSearchParams(params).toString();
    const base = groupId ? `/groups/${groupId}/activity-feed` : '/activity-feed';
    const response = await this.request(`${base}${query ? '?' + query : ''}`);
    return response;
  },

  // Stats follow the feed's scope. A group gets the GROUP's numbers — passing
  // no groupId used to be the only option, so group ledgers showed none at all.
  async getActivityStats(groupId = null) {
    const base = groupId ? `/groups/${groupId}/activity-feed/stats` : '/activity-feed/stats';
    return this.request(base);
  },

  async getLogPreferences() {
    const response = await this.request('/user/log-preferences');
    return response.preferences || { enabled_categories: ['node', 'app_access', 'data_read', 'security', 'error'] };
  },

  // Node Ledger (all agents that contributed)
  async getNodeLedger(nodeId) {
    const response = await this.request(`/nodes/${nodeId}/ledger`);
    return response;
  },

  // Node version history (with snapshots)
  async getNodeVersions(nodeId) {
    const response = await this.request(`/nodes/${nodeId}/history?include_snapshots=true&limit=50`);
    return response.history || [];
  },

  // Revert node to a previous version
  async revertNodeToVersion(nodeId, version) {
    return this.request(`/nodes/${nodeId}/revert/${version}`, { method: 'POST' });
  },

  // Graph Snapshots (Time-travel)
  async getGraphSnapshot(timestamp) {
    const response = await this.request(`/graph/snapshot?timestamp=${encodeURIComponent(timestamp)}`);
    return response;
  },
};
